import $ from 'jquery';
window.dataLayer = window.dataLayer || [];

const impactCalculator = () => {
    const $impactCalculator = $('.c-impact-calculator');
    if (!$impactCalculator.length) return;
    const $donationSlider = $('#donationSlider');
    const $donationInput = $('#donationInput');
    const $impactDonation = $('.impact-donation');
    const $donationSubmit = $('.FormButton');
    const $impactCalculatorSubmit = $('.js-impact-calc-submit');

    const impactValues = $("div[id^='impact-value']");
    const impactMultipliers = JSON.parse($impactCalculator.attr('data-multipliers'));
    const incrementer = $impactCalculator.attr('data-incrementer');

    // handles slider to grow according to incrementer amount when input field interacted with
    $donationInput.on('input', () => {
        $donationSlider[0].value = $donationInput[0].value / parseInt(incrementer, 0);
    });

    // handles slider to grow according to incrementer amount when interacted with
    $donationSlider.on('input', () => {
        $donationInput[0].value = $donationSlider[0].value * parseInt(incrementer, 0);
    });

    // updates all impact values and slider background styling
    const updateSlider = (() => {
        const value = (($donationSlider[0].value / $donationSlider[0].max) * 100);
        $donationSlider[0].style.background = `linear-gradient(to right, #009CA6 ${value}%, #F0F0F0 ${value}%)`;

        const donateValue = $donationInput[0].value;

        $donationInput[0].addEventListener('input', resizeInput); // bind the "resizeInput" callback on "input" event
        resizeInput.call($donationInput[0]); // immediately call the function

        function resizeInput() {
            if (!this.value.length) {
                this.style.width = this.value.length + 2 + "ch";
            } else {
                this.style.width = this.value.length + 1 + "ch";
            }
        }

        if ($impactDonation[0].value.length > 8) {
            $impactDonation[0].value = $impactDonation[0].value.slice(0, 8);
        } else {
            // handles inner impact text to prevent elongated numbers
            for (let i = 0; i < impactValues.length; i += 1) {
                const currentImpact = Math.round(donateValue * impactMultipliers[i]).toString();
                if (currentImpact.length < 4) {
                    impactValues[i].innerText = currentImpact;
                } else if (currentImpact.length >= 4 && currentImpact.length < 7) {
                    const newImpactValue = currentImpact.slice(0, -3).concat('k');
                    impactValues[i].innerText = newImpactValue;
                } else {
                    const newImpactValue = currentImpact.slice(0, -6).concat('mil');
                    impactValues[i].innerText = newImpactValue;
                }
            }
        }

        $donationSubmit[0].value = `DONATE $${$donationInput[0].value} NOW`;

        // handles either slider or input reset
        if ($donationInput[0].value === '' || $donationInput[0].value === '0') {
            $donationSubmit.addClass('btn-disabled');
            $donationSubmit[0].value = 'DONATE $0 NOW';
            $donationInput[0].value = '';
            $donationSlider[0].value = 0;
            $donationSlider[0].style.background = '#F0F0F0';
        } else {
            $donationSubmit.removeClass('btn-disabled');
        }
    });

    $impactDonation.on('input', () => {
        updateSlider();
    });

    $impactCalculatorSubmit.on('click', function(e) {
        e.preventDefault();

        const dAmt = $donationInput[0].value;

        if (dAmt !== '') {
            // eslint-disable-next-line
            sessionStorage.setItem('dAmt', Base64.encode(dAmt));
    
            window.dataLayer.push({
                'event': 'impact_calculator_button_click',
                'buttonId': 'impact_calculator_donate_button'
            });

            // eslint-disable-next-line
            javascript: __doPostBack('ImpactCalculator', 'Click');
        }
    });

    updateSlider();
};

$(() => {
    impactCalculator();
});




// WEBPACK FOOTER //
// ./src/components/impact-calculator/c-impact-calculator.js